module.exports = __webpack_public_path__ + "media/img/apple-icon-152x152-eea972657cbcf5b986bb1cc93ae807b6.png";